import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { GuideType, GuideTypeOption } from '@/modules/ConfiguratorCombinations/composables/useGuideImages';

interface Props {
    x: number;
    y: number;
    value: GuideType | null;
    options: GuideTypeOption[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GuideTypeSelectorModal',
  props: {
    x: null,
    y: null,
    value: null,
    options: null
  },
  emits: ["select", "close"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'select', value: GuideType): void;
    (event: 'close'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    x: number;
    y: number;
    value: GuideType | null;
    options: GuideTypeOption[];
};





const positionStyle = computed(() => ({
    left: `${props.x}px`,
    top: `${props.y}px`,
}));

function onSelect(value: GuideType): void {
    emit('select', value);
    emit('close');
}

function getPopupContainer(trigger: HTMLElement): HTMLElement {
    return trigger.parentElement ?? trigger;
}

return { __sfc: true,props, emit, positionStyle, onSelect, getPopupContainer }
}

})